/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    "use strict";
    /**
     * <h3>按钮控件</h3>
     * <a href="../../ui_controls/bui.btn.html" target="_blank">demo</a>
     * {{#crossLink "bui.btn/load"}}{{/crossLink}}: 页面跳转,支持单个页面跟容器内的多个按钮 <br>
     * {{#crossLink "bui.btn/submit"}}{{/crossLink}}: 提交数据<br>
     *  @namespace bui
     *  @class btn
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]  
     *  @param {string} [option.handle] [点击区域] 
     *  @example
     * 
     *   html:
     *
            <div id="btn" href="index.html">按钮</div>
     *      
     *   js: 
     *   
            
     *   方法1: 
     *   
            //快速绑定跳转
            bui.btn("#btn").load();
            
     *   方法2: 
     *   
            //引用 
            var uiBtn = bui.btn("#btn");
            //跳转
            uiBtn.load();
     *
     */
    ui.btn = function (option) {

        var $id,
            param = {},
            $children;

        //初始化
        init(option);
        
        function init (option) {

          //id 传的是否是json ,这里统一了控件的初始化方式,快速初始化则不用
          if( typeof option === "object"  ){

            param.id = option["id"] || "";
            param.handle = option["handle"] || "";

          }else if( typeof option === "string"){
            // 如果传的是字符串,则可能会有2个参数
              param.id = option || "";
              param.handle = "";
          }

          //初始化选择器
          $id = ui.obj(param["id"]);
          $children = param["handle"];

          return this;
        }

        /**
         * 页面跳转,跟 {{#crossLink "bui.load"}}{{/crossLink}} 的区别在于,通过按钮绑定跳转会增加一层防止快速点击加载2次的问题,更多demo请查看 modules/btn_method.html
         * 注意: 这个默认跳转会阻止默认事件,a, input的checkbox label的for 等等,包在btn元素里面都会失效
         * 页面如何接收参数请查看 {{#crossLink "bui.getPageParams"}}{{/crossLink}}
         *  @method load
         *  @param {string} [url] [跳转的地址]
         *  @param {object} [param] [跳转的传参]
         *  @param {boolean} [progress] [显示进度条 ]
         *  @example 
         *  
         *  示例1: 一个按钮跳转
         *
         *  html:
         *  
                <div id="btn">单个按钮</div>
         *  js:
         *  
                bui.btn("#btn").load("index.html",{"id":index},true);
        
         *  示例2: 多个按钮跳转
         *  
         *  html:
         *  
           <div id="page">
               <div class="bui-btn" href="btn.html">首页</div>
               <div class="bui-btn" href="btn.html" param='{"id":"222"}'>新闻</div>
           </div>
        *  js:
        *  
            bui.btn({ 
                id:"#page",
                handle: ".bui-btn"
            }).load();

            //开启进度条
            //.load(true);
                
         */
        function load (url,param,progress) {

            //进度条参数是否提前
            if( typeof url === "boolean"){
                progress = url;
                url = "";
                param = {};
            }else if( typeof param === "boolean"){
                progress = param;
                url = url;
                param = {};
            }else{
              url = url;
              param = param;
              progress = progress;
            }

            //重新赋值
            var progress = progress,
                param = param,
                url = url,
                timeout;


            off();

            $id.on("click.bui",$children,function (e) {
                
                var self = this;

                //兼容以前的写法
                var href = url || $(this).attr("href"),
                    target = $(this).attr("target"),
                    disabled = $(this).hasClass("disabled");

                if( !href || disabled ){
                  return;
                }
                
                //传过去的参数
                var paramStr = $(this).attr("param") || "";
                var param2 = (paramStr && paramStr.indexOf("{") > -1) ? JSON.parse( $(this).attr("param") ): {};
                
                //合并参数
                var paramObj = $.extend(true, param2, param);
                
                //如果需要跳转加上进度条
                if( progress ){
                    ui.loading();
                }
                
                //解决BT的快速点击导致页面加载两次, 如果在滑动的时候,继续点击,还是会触发两次,这个需要在原生层面解决.
                var mask = ui.mask({ 
                        id: $id,
                        opacity:0
                    });

                if( timeout){
                    clearTimeout(timeout);
                }
                  timeout = setTimeout(function(){ mask.remove(); }, 500);

                //传参数
                var params = {url:href,param:paramObj };

                //网址是http://开头
                if( target == "_blank"){
                    ui.run( href, paramObj )
                }else{

                    //页面跳转
                    ui.load(params);
                }

                //阻止原有的事件跳转
                //return false;
            })

        };
        
        
        /**
         * 提交数据,提交数据成功以后需要在回调里面关闭进度条
         *  @method submit
         *  @param {function} callback [提交的回调]
         *  @param {object} param [ loading 的参数修改]
         *  @example 
            
            bui.btn("#btn").submit(function(loading){ 
                 //关闭进度条
                 loading.stop(); 
             });
                
         */
        function submit (callback,param) {

            var param = param || {};

            off();

            $id.on("click.bui",$children,function (e) {

                var self = this;

                //覆盖原来的颜色
                var background = $(self).css("background") || "#ffffff";

                param.appendTo = self;
                param.background = param.background || background;
                param.autoClose = param.autoClose == false ? false : true;

                //创建loading
                var loading = ui.loading(param);

                // 在回调中手动关闭进度 loading.stop();
               return callback && callback.call(self,loading);

            });
        };


        /**
         * 取消事件
         *  @method off
         *  @example 
            
            bui.btn("#btn").off();
                
         */
        function off() {

            $id.off("click.bui",$children);

            return this;
        }

        /**
         * 获取依赖的控件, 折叠菜单没有直接依赖的控件
         *  @method widget
         *  @example 
            
            //获取依赖控件
            var uiAccordionWidget = uiAccordion.widget();
            
                
         */
        function widget() {
            var control = {};
            return ui.widget.call(control,name);
        };
        return {
            load: load,
            submit: submit,
            off: off
        }
    };

    return ui;

})( bui || {}, libs );
